import Header from '../../common/Header/Header';
import './JobShow.scss';
import { useEffect, useState } from 'react';
import Packages from '../../api/controllers/Packages/Packages';
import Job from '../../api/controllers/Job/Job';
import Hub from '../../api/controllers/Hub/Hub';
import Error from '../../common/Error/Error';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import PackageList from '../../common/PackageList/PackageList';
import PhotoList from '../../common/PhotoList/PhotoList';
import Attachment from '../../api/controllers/Attachment/Attachment';
import Modal from '../../common/Modal/Modal';
import AddPhoto from '../../common/AddPhoto/AddPhoto';

// JobShow screen Component
const JobShow = () => {
  const [error, setError] = useState();
  const [packages, setPackages] = useState();
  const [completePackages, setCompletePackages] = useState();
  const [job, setJob] = useState();
  const [bays, setBays] = useState();
  const [racks, setRacks] = useState();
  const [baysAndRacks, setBaysAndRacks] = useState();
  const [modalOpen, setModalOpen] = useState();
  const [attachments, setAttachments] = useState();

  const hubId = JSON.parse(localStorage.getItem('user')).currentHubId;
  const jobId = location.pathname.split('/')[2];

  const expQuantity = job?.quantity;
  const actQuantityPackages = packages?.length;
  const actQuantityItems = packages?.map(pkg => pkg.quantity).reduce((a, b) => a + b, 0);
  const actType = packages?.every(
    pkg => pkg.packageType.shortName == packages[0]?.packageType.shortName,
  )
    ? packages[0]?.packageType.shortName
    : 'pkg';
  const expWeight = job?.grossWeightKg;
  const actWeight = packages?.map(pkg => pkg.grossWeightKg).reduce((a, b) => a + b, 0);
  const expVolume = Number(job?.cubicMetres)?.toFixed(2);
  const actVolume = packages
    ?.map(pkg => Number(pkg.cubicMetres))
    .reduce((a, b) => a + b, 0)
    .toFixed(2);

  const getPackages = () => {
    const params = { hubId: hubId, jobId: jobId, status: 'in_warehouse' };
    Packages.all(params)
      .then(response => {
        setPackages(response.items);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  const getCompletePackages = () => {
    const params = { hubId: hubId, jobId: jobId, status: 'complete' };
    Packages.all(params)
      .then(response => {
        setCompletePackages(response.items);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  const getJob = () => {
    Job.show(jobId)
      .then(response => {
        setJob(response);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  const getHub = () => {
    Hub.show(hubId)
      .then(response => {
        setBaysAndRacks(response.bays);
        setBays(response.bays.filter(bay => bay.bayType != 'racking'));
        const racks = response.bays.filter(bay => bay.bayType == 'racking');
        setRacks(Object.groupBy(racks, rack => rack.bayNumber));
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  const getAttachments = () => {
    Attachment.all({ parentType: job?.modelName, parentId: job?.id, photos: true })
      .then(response => {
        setAttachments(response.items);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    getJob();
    getPackages();
    getCompletePackages();
    getHub();
  }, []);

  useEffect(() => {
    if (job) {
      getAttachments();
    }
  }, [job]);

  const baysToDisplay = packages
    ?.map(pkg => pkg.bayId)
    .filter((value, index, array) => array.indexOf(value) === index);

  return (
    <>
      <div className="job_show_screen">
        <Header hideQR leftButton={'back'} title={job?.jobReference || ' '} rightButton={'home'} />
        <div className="job_show_container">
          {error && (
            <Error
              errorMessages={error}
              type={'info'}
              errorTitle={
                Array.isArray(error)
                  ? `${error.length} error${error.length > 1 ? 's occurred:' : ' occurred:'} `
                  : ''
              }
            />
          )}
          {!(packages && bays && racks && job) && !error && <LoadingSpinner />}
          <div className="job_information">
            <div className="job_ref">Job Ref:</div>
            <div className="value">{job?.jobReference}</div>
            <div className="job_controller">Controller:</div>
            <div className="value">
              {job?.jobController?.firstName} {job?.jobController?.lastName}
            </div>
            <div className="job_shipper">Shipper:</div>
            <div className="value">
              {job?.shipper?.name} {job?.shipper?.businessType?.shortForm}
            </div>
            <div className="job_consignee">Consignee:</div>
            <div className="value">
              {job?.consignee?.name} {job?.consignee?.businessType?.shortForm}
            </div>
            <div className="job_marks_nos">Marks/Nos: </div>
            <div className="value">
              {job?.marksLine1}
              {job?.marksLine2 ? `, ${job?.marksLine2}` : ''}
              {job?.marksLine3 ? `, ${job?.marksLine3}` : ''}
              {job?.marksLine4 ? `, ${job?.marksLine4}` : ''}
            </div>
          </div>
          <div className="job_expected_actual_values">
            <div className="packages_expected_quantity">{'Expected Quantity: '}</div>
            <div className="value">
              {expQuantity} {job?.packageType?.shortName}
            </div>
            <div className="packages_actual_quantity">{'Actual Quantity: '}</div>
            <div
              className={`value ${
                actQuantityItems != actQuantityPackages
                  ? 'item_mismatch'
                  : actQuantityPackages == expQuantity
                  ? 'match'
                  : 'mismatch'
              }`}
            >
              {actQuantityPackages} {actType}{' '}
              {actQuantityItems != actQuantityPackages && `(${actQuantityItems} items)`}
            </div>
            <div className="packages_expected_weight">{'Expected Weight: '}</div>
            <div className="value">{expWeight} kg</div>
            <div className="packages_actual_weight">{'Actual Weight: '}</div>
            <div className={`value ${actWeight == expWeight ? 'match' : 'mismatch'}`}>
              {actWeight} kg
            </div>
            <div className="packages_expected_volume">{'Expected Volume: '}</div>
            <div className="value">{expVolume} m³</div>
            <div className="packages_actual_volume">{'Actual Volume: '}</div>
            <div className={`value ${actVolume == expVolume ? 'match' : 'mismatch'}`}>
              {actVolume} m³
            </div>
          </div>
          <div className="package_display">
            {packages &&
              baysAndRacks &&
              baysToDisplay.map(bay => {
                const bayObject = baysAndRacks.find(b => b.id == bay);
                return (
                  <div className="bay_package_list" key={bay}>
                    <div className="bay_title">
                      {`${
                        bayObject
                          ? `Bay ${`${bayObject?.bayType[0]}${bayObject?.bayNumber}`.toUpperCase()}`
                          : 'Unassigned'
                      } (${packages.filter(pkg => pkg.bayId == bay).length} item${
                        packages.filter(pkg => pkg.bayId == bay).length > 1 ? 's' : ''
                      })`}
                    </div>
                    <PackageList
                      packages={packages.filter(pkg => pkg.bayId == bay)}
                      bays={bays}
                      racks={racks}
                      refetchPackages={() => {
                        getPackages();
                        getCompletePackages();
                      }}
                      specialActionType={'manually_complete'}
                    />
                  </div>
                );
              })}
            {completePackages?.length > 0 && (
              <div className="bay_package_list">
                <div className="bay_title">
                  {`Dispatched (${completePackages.length} item${
                    completePackages.length > 1 ? 's' : ''
                  })`}
                </div>
                <PackageList
                  disableMassAssign
                  packages={completePackages.filter(pkg => pkg.manualCompletionReason)}
                  bays={bays}
                  racks={racks}
                  refetchPackages={() => {
                    getPackages();
                    getCompletePackages();
                  }}
                  specialActionType={'complete_packages'}
                  completedPackages={completePackages.filter(pkg => !pkg.manualCompletionReason)}
                />
              </div>
            )}
          </div>
          <div className="attach_photos_job">
            <div>
              <div className="title">Additional Photos</div>
              <div>Images not associated with a specific collection, delivery, or trailer:</div>
            </div>

            <button className="job_button attach_photo" onClick={() => setModalOpen('add_photo')}>
              Attach photo
            </button>
          </div>
          <div className="job_notes_photos">
            <PhotoList
              photos={attachments}
              refetchPhotos={getAttachments}
              modelName={job?.modelName}
              setError={setError}
            />
          </div>
        </div>
      </div>
      {modalOpen && (
        <Modal
          title={'Photo'}
          content={
            <AddPhoto
              refetchPhotos={getAttachments}
              setModalOpen={setModalOpen}
              modelName={job?.modelName}
              movementId={job?.id}
            />
          }
          setModalOpen={setModalOpen}
        />
      )}
    </>
  );
};

export default JobShow;
